import { render } from "./GeneratedAlerts.view.vue?vue&type=template&id=caec4dfc&scoped=true&ts=true"
import script from "./GeneratedAlerts.view.vue?vue&type=script&lang=ts"
export * from "./GeneratedAlerts.view.vue?vue&type=script&lang=ts"

import "./GeneratedAlerts.view.vue?vue&type=style&index=0&id=caec4dfc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caec4dfc"]])

export default __exports__